var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Icon } from "../../UI";
import { withContext } from "../../componentWrappers";
import { I18NLink, t } from "../../I18N";

import { switchOneUpEntity, toggleOneUpFullEdit } from "../actions/actions";
import { selectIsPristine, selectOneUpState } from "../common";

const defaultProps = {
  isPristine: true,
  oneUpState: {},
  switchOneUpEntity: (_delta, _save) => {},
  mainContext: { confirm: (_props) => {} }
};



class OneUpTitleBarBase extends Component {


  backToThesaurus() {
    const { oneUpState, isPristine } = this.props;
    if (oneUpState.reviewThesaurusName) {
      return (/*#__PURE__*/
        _jsx(I18NLink, {
          to: `/settings/dictionaries/cockpit/${oneUpState.reviewThesaurusId}`,
          className: "btn btn-default",
          confirmTitle: isPristine ? '' : 'Confirm discard changes',
          confirmMessage:
          isPristine ?
          '' :
          'There are unsaved changes. Are you sure you want to discard them and navigate away?' }, void 0, /*#__PURE__*/


        _jsx(Icon, { icon: "arrow-left" }), /*#__PURE__*/
        _jsx("span", { className: "btn-label" }, void 0,
        t('System', 'Back to'), " ", /*#__PURE__*/_jsx("span", {}, void 0, `'${oneUpState.reviewThesaurusName}'`)
        )
        ));

    }
    return null;
  }

  navButtons() {
    const { oneUpState, isPristine } = this.props;
    const prevClass = oneUpState.indexInDocs > 0 ? '' : ' btn-disabled';
    const nextClass = oneUpState.indexInDocs < oneUpState.totalDocs - 1 ? '' : ' btn-disabled';
    const navAction = isPristine ?
    (delta) => () => this.props.switchOneUpEntity(delta, false) :
    (delta) => () =>
    this.props.mainContext.confirm({
      accept: () => this.props.switchOneUpEntity(delta, false),
      title: 'Confirm discard changes',
      message:
      'There are unsaved changes. Are you sure you want to discard them and switch to a different document?'
    });
    return (/*#__PURE__*/
      _jsx("span", {}, void 0, /*#__PURE__*/
      _jsx("button", { type: "button", onClick: navAction(-1), className: `btn btn-default${prevClass}` }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "arrow-left" })
      ), /*#__PURE__*/
      _jsx("button", { type: "button", onClick: navAction(+1), className: `btn btn-default${nextClass}` }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "arrow-right" })
      )
      ));

  }

  render() {
    const { oneUpState } = this.props;

    return (/*#__PURE__*/
      _jsx("div", { className: "content-header-title" }, void 0,
      this.backToThesaurus(),
      oneUpState.reviewThesaurusValues && oneUpState.reviewThesaurusValues.length === 1 ? /*#__PURE__*/
      _jsx("span", { className: "large" }, void 0, /*#__PURE__*/
      _jsx("span", { className: "space8" }),
      t('System', 'Documents including suggestion:'), ' ', /*#__PURE__*/
      _jsx("b", {}, void 0, `'${oneUpState.reviewThesaurusValues[0]}'`), /*#__PURE__*/
      _jsx("span", { className: "separator" })
      ) : /*#__PURE__*/

      _jsx("span", { className: "large" }, void 0, /*#__PURE__*/
      _jsx("span", { className: "space8" }),
      t('System', 'Documents for custom filter'), /*#__PURE__*/
      _jsx("span", { className: "separator" })
      ),

      oneUpState.totalDocs ? /*#__PURE__*/
      _jsx("div", {}, void 0,
      t('System', 'Document'), " ", /*#__PURE__*/_jsx("span", {}, void 0, oneUpState.indexInDocs + 1), " ", t('System', 'of'), ' ', /*#__PURE__*/
      _jsx("span", {}, void 0,
      oneUpState.totalDocs >= oneUpState.maxTotalDocs ?
      `>${oneUpState.totalDocs - 1}` :
      `${oneUpState.totalDocs}`
      ), /*#__PURE__*/
      _jsx("span", { className: "space8" })
      ) :

      t('System', 'No Documents found'),

      this.navButtons()
      ));

  }
}_defineProperty(OneUpTitleBarBase, "defaultProps", defaultProps);

const mapStateToProps = (state) => {var _selectOneUpState;return {
    isPristine: selectIsPristine(state),
    oneUpState: (_selectOneUpState = selectOneUpState(state)) !== null && _selectOneUpState !== void 0 ? _selectOneUpState : {}
  };};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      switchOneUpEntity,
      toggleOneUpFullEdit
    },
    dispatch
  );
}

export { OneUpTitleBarBase };

export const OneUpTitleBar = connect(
  mapStateToProps,
  mapDispatchToProps
)(withContext(OneUpTitleBarBase));